module.exports = __webpack_public_path__ + "static/media/download.9f76c1d4.jpg";